import React, { Component } from 'react';
import PropTypes from 'prop-types';

class SvgWrapper extends Component {
    render() {
        const { classes, svgKey, svgPaths, children, textPaths, sectionEvaluation, detailPageContent } = this.props;

        return (
            <div key={ svgKey }
                 className={ classes.workEnvironmentSvgWrapper }>
                { children }
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 102 102"
                    width='175'
                    height='175'
                >
                    <defs>
                        <style/>
                        <clipPath id="clip-path">
                            <rect className={ classes.root } width="102" height="102"/>
                        </clipPath>
                        <clipPath id="clip-path-4">
                            <rect className={ classes.root } x="18.45" y="17.7" width="32.02" height="32.02"/>
                        </clipPath>
                        <clipPath id="clip-path-6">
                            <rect
                                className={ classes.root }
                                x="52.47"
                                y="51.72"
                                width="32.02"
                                height="32.01"
                            />
                        </clipPath>
                        <clipPath id="clip-path-7">
                            <rect
                                className={ classes.root }
                                x="52.47"
                                y="51.72"
                                width="32.02"
                                height="32.01"
                            />
                        </clipPath>
                        <clipPath id="clip-path-8">
                            <rect
                                className={ classes.root }
                                x="18.75"
                                y="51.71"
                                width="32.02"
                                height="32.02"
                            />
                        </clipPath>
                        <clipPath id="clip-path-9">
                            <rect
                                className={ classes.root }
                                x="18.75"
                                y="51.71"
                                width="32.02"
                                height="32.02"
                            />
                        </clipPath>
                    </defs>
                    {svgPaths}
                    {textPaths}
                </svg>
                { sectionEvaluation ? <p className={classes.workEnvironmentSectionEvaluation}>{ sectionEvaluation }</p> : null }
            </div>
        );
    }
}
export default SvgWrapper;

SvgWrapper.propTypes = {
    svgKey: PropTypes.string,
    svgPaths: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    textPaths: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    classes: PropTypes.shape({
        root: PropTypes.string
    }),
    sectionEvaluation: PropTypes.string,
    detailPageContent: PropTypes.bool
};

SvgWrapper.defaultProps = {
    svgKey: '',
    svgPaths: [],
    textPaths: [],
    classes: {},
    sectionEvaluation: '',
    detailPageContent: false
};
